import {
  useContext, useEffect,
  // ,
  // useEffect,
  //   useState
} from "react";
import "./TostMessageComponent.scss";
import { TostMessageContext } from "../context/TostMessage";
import { FaCheck } from "react-icons/fa";
import { IoWarning } from "react-icons/io5";
import { CgDanger } from "react-icons/cg";

function TostMessageComponent() {
  const { tostMessage, setTostMessage } = useContext(TostMessageContext);

  useEffect(() => {
    if (tostMessage.messageType != "") {
      setTimeout(() => {
        setTostMessage({ messageType: "", message: "" })
      }, 5000)
    }
  }, [tostMessage])

  return (
    <>
    {tostMessage.messageType == "success" && (
      <div onClick={() => setTostMessage({ messageType: "", message: "" })} className="opacity-[0.99] overflow-hidden shadow-2xl border border-l-[0.5px] border-l-[5px] border-[#01E17B] flex flex-row justify-between items-center fixed right-3 top-7 sm:right-7 z-[100000] w-auto py-3 rounded-[10px] bg-[#1e1a14]">
        <div className="outline outline-[#ffffff]/[.20] outline-[8px]  shadow-3xl-yellow h-7 w-7 flex items-center justify-center bg-[#00b47a] mx-[20px] rounded-lg">
          <FaCheck color="#242C32" size={15} />
        </div>
        <div className="px-3 flex flex-col max-w-[300px]">
            <b className="text-sm text-white">{'Success'}</b>
            <b className="text-sm text-white/70">{tostMessage.message}</b>
        </div>
      </div>
    )}
    {tostMessage.messageType == "warning" && (
      <div style={{ position: 'fixed', zIndex: 9999}} onClick={() => setTostMessage({ messageType: "", message: "" })} className="opacity-[0.99] overflow-hidden shadow-2xl border border-l-[0.5px] border-l-[5px] border-[#FFD21F] flex flex-row justify-between items-center fixed right-3 top-7 sm:right-7 z-[100000] w-auto py-3 rounded-[10px] bg-[#1e1a14]">
        <div className="outline outline-[#ffffff]/[.20] outline-[8px]  shadow-3xl-yellow h-7 w-7 flex items-center justify-center bg-[#FFD21F] mx-[20px] rounded-lg">
          <IoWarning color="#242C32" size={15} />
        </div>
        <div className="px-3 flex flex-col max-w-[300px]">
            <b className="text-sm text-white">{'Warning'}</b>
            <b className="text-sm text-white/70">{tostMessage.message}</b>
        </div>
      </div>
    )}
    {tostMessage.messageType == "error" && (
      <div onClick={() => setTostMessage({ messageType: "", message: "" })} className="opacity-[0.99] overflow-hidden shadow-2xl border border-[0.5px] border-l-[7px] border-[#ff0000] flex flex-row justify-between items-center fixed right-3 top-7 sm:right-7 z-[100000] w-auto py-4 rounded-[10px] bg-[#1e1a14]">
        <div className="outline outline-[#ffffff]/[.20] outline-[8px]  shadow-3xl-yellow h-7 w-7 flex items-center justify-center bg-[#ff0000] mx-[20px] rounded-lg">
          <CgDanger color="#242C32" size={15} />
        </div>
        <div className="px-3 flex flex-col max-w-[300px]">
            <b className="text-sm text-white">{'Error'}</b>
            <b className="text-sm text-white/70">{tostMessage.message}</b>
        </div>
      </div>
    )}
    </>
  );
}

export default TostMessageComponent;
